// extracted by mini-css-extract-plugin
module.exports = {"quoteTitle":"text-block-module--quoteTitle--2YMr7","textContent":"text-block-module--textContent--3FZ4I","image":"text-block-module--image--1Zvf2"};